import React, { useState, useEffect } from "react";
import { useMixpanel } from "../context/MixpanelContext";
import { useGoogleAnalytics } from "../context/GoogleAnalyticsContext";

const useAnalytics = (payload = {}, trackers = ["ga"]) => {
  const enableMixpanel = trackers.includes("mixpanel");
  const enableGA = trackers.includes("ga");
  const mixpanel = useMixpanel(enableMixpanel);
  const reactGA = useGoogleAnalytics(enableGA);

  const [trackerData, setTrackerData] = useState(payload);

  /**
   * tracker data will come in in a generic format from the payload object
   * the payload will have an 'action' value, which will determine which
   * method to call on each respective analytics tracker
   */
  useEffect(() => {
    //console.log({ trackerData });
    switch (trackerData.action) {
      case "pageview":
        if (enableMixpanel) {
          mixpanel.track("Pageview", { url: trackerData.url });
        }

        if (enableGA) {
          reactGA.pageview(trackerData.url);
        }
        break;
      case "trackLink":
        if (enableMixpanel) {
          mixpanel.track_links(
            trackerData.selector,
            trackerData.eventDescription,
            trackerData.eventProperties
          );
        }
        break;
      case "event":
        if (enableMixpanel) {
          mixpanel.track(
            trackerData.eventDescription,
            trackerData.eventProperties
          );
        }

        if (enableGA) {
          reactGA.event({
            category: trackerData?.category || "User",
            action: trackerData.gaAction,
            label: trackerData.gaLabel
          });
        }

        break;
      default:
        break;
    }
  }, [trackerData, mixpanel, reactGA, enableMixpanel, enableGA]);

  return setTrackerData;
};

function withAnalytics(Component) {
  return function ({ payload = {}, trackers = ["ga"], ...others }) {
    const setTrackerData = useAnalytics(payload, trackers);
    return <Component setTrackerData={setTrackerData} {...others} />;
  };
}

export default useAnalytics;
export { withAnalytics };
